import {
  Assignment,
  AssignmentWithUnknownDomain,
  Brand,
  CKLA_DOMAIN,
  isRelevant,
} from 'shared/api/assignment-service';
import { getPage } from 'shared/api/event-service';
import { RelevantDomains } from 'shared/lib/domains';
import { getAssignmentContent } from 'shared/lib/utils';
import { dateService } from 'shared/lib/date';

export const filterBySubjects = (
  assignments: Assignment[] | null = null,
  subjects: RelevantDomains[] = [],
) =>
  subjects.length && assignments
    ? assignments.filter((assignment) => {
        const assignmentContent = getAssignmentContent(assignment);

        return (
          assignmentContent.brand !== Brand.CUSTOM &&
          subjects.find((subject) => {
            if (subject === CKLA_DOMAIN) {
              return assignmentContent.domain === CKLA_DOMAIN;
            }
            return assignmentContent.domain.startsWith(subject);
          })
        );
      })
    : assignments;

export const getFilteredRelevantAssignments = (
  subjects: RelevantDomains[] = [],
  assignments?: AssignmentWithUnknownDomain[] | null,
) => {
  const assignmentsFilteredByRelevantDomains =
    assignments && assignments.filter(isRelevant);

  return filterBySubjects(assignmentsFilteredByRelevantDomains, subjects);
};

export const isScheduledAssignment = (
  assignment: AssignmentWithUnknownDomain | Assignment,
) => {
  if (!assignment.startDate) return false;

  const assignmentDate = assignment.startDate;
  const currentDate = dateService.getDateObject();

  return dateService.getDiff(assignmentDate, currentDate) > 0;
};

export const isNonScheduledAssignment = (
  assignment: AssignmentWithUnknownDomain | Assignment,
) => {
  if (!assignment.startDate) return true;

  const assignmentDate = assignment.startDate;
  const currentDate = dateService.getDateObject();

  return dateService.getDiff(assignmentDate, currentDate) <= 0;
};

export const filterScheduledAssignments = (
  data: AssignmentWithUnknownDomain[] | null | undefined,
) => {
  if (!data) return data;

  return data.filter(isScheduledAssignment);
};

export const getAssignmentSection = (assignment: Assignment) => {
  if (getPage() !== 'main') {
    return;
  }

  return isScheduledAssignment(assignment) ? 'scheduled' : 'stream';
};
